import React from "react";
import Chart from "react-apexcharts";
import { GoLinkExternal } from "react-icons/go";
import { Link } from "react-router-dom";
import { encrypt } from "../Utils/Encryption";

const contrastColors = [
  "#5B9BD5", "#70AD47", "#FFC000", "#ED7D31", "#A5A5A5",
  "#4472C4", "#E2725B", "#7FB3D5", "#C5E0B4", "#F4B084"
]

const DashboardBarChart = ({ metricData, status = 1 }) => {
  const coordinates = metricData?.coordinates ? JSON.parse(metricData.coordinates) : {};
  const valueType = coordinates?.value_type ?? coordinates?.datasets?.[0]?.value_type ?? "";

  const categories = metricData.value.map((item) => item.name || "");
  const values = metricData.value.map((item) => parseFloat(item.value));

  const barColors = contrastColors.slice(0, values.length);

const formatValue = (val) => {
  let formatted = val;
  if (typeof val === "number" && val > 1000000000 && val < 9999999999999) {
    const date = val > 9999999999 ? new Date(val) : new Date(val * 1000);
    formatted = date.toLocaleString();
  } else if (typeof val === "number" && !Number.isInteger(val)) {
    formatted = val.toFixed(2);
  }
  if (valueType === "Nos") {
    return `${formatted} Nos`;
  }
  if (valueType) {
    return `${valueType}${formatted}`;
  }
  return formatted;
};

  const options = {
    chart: { type: "bar" },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "50%",
        distributed: true,
      },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories,
      title: {
        text: coordinates?.xAxis || "X-Axis",
        style: { fontWeight: "", fontSize: "16px" },
      },
    },
    yaxis: {
      title: {
        text: coordinates?.yAxis || "Y-Axis",
        style: {
          fontWeight: "",
          color: "#666",
          fontSize: "16px",
          fontFamily: "sans-serif",
        },
      },
      labels: {
        formatter: formatValue,
        style: {
          fontWeight: "",
          color: "#666",
          fontSize: "12px",
          fontFamily: "sans-serif",
        },
      },
    },
    legend: { show: true },
    tooltip: {
      y: {
        formatter: formatValue,
      },
    },
    colors: barColors,
  };

  const series = [
    {
      name: metricData.metric_name || "Series",
      data: values,
    },
  ];

  return (
    <div className="col-12 h-100 ChartData">
      <div className="dashboardCharttitleContainer">
        {(metricData?.child && status == 1) && metricData?.metric_id  ? (
          <Link
            to={`/dashboard/childmetric/${metricData.metric_name}/${encrypt(
              metricData.metric_id.toString()
            )}/1`}
            className="dashboardCharttitle dashboardCharttitleActive"
          >
            <span className="text-md">{metricData?.metric_name}</span>
            <GoLinkExternal className="externelLink" />
          </Link>
        ) : (
          <div className="dashboardCharttitle">
            <span className="text-md">{metricData?.metric_name}</span>
          </div>
        )}
      </div>

      <div className="dashboardChart col-12">
        <Chart
          options={options}
          series={series}
          type="bar"
          width="100%"
          height={350}
          className="charts"
        />
      </div>
    </div>
  );
};

export default DashboardBarChart;
